<template>
    <TemplatesPage :error-message="error">
        <InlineMessage v-if="skips" severity="error">
            <div>{{ $t('lang.tools.compare.domains_ignore') }}</div>
            <ul>
                <li v-for="(a, b) in skips"><b>{{ a }}</b> &mdash; {{ b }}</li>
            </ul>
        </InlineMessage>
        <form action="" method="GET">
            <div class="field">
                <TemplatesLabelCounts :text="$t('lang.tools.compare.domains_in_report')" :count="count" :limit="maxList" />
                <Textarea
                    name="domains"
                    :placeholder="$t('lang.tools.compare.domains_in_report_placeholder')"
                    v-model="list"
                    rows="6"
                />
            </div>
            <input type="hidden" name="view" :value="viewType" />
            <div class="mb-4">
                <Button type="submit" :label="$t('lang.tools.compare.submit_form')" />
            </div>
        </form>
    </TemplatesPage>
</template>

<script>
import Button from "primevue/button";
import Textarea from "primevue/textarea";
import InlineMessage from "primevue/inlinemessage";
import TemplatesPage from "../../templates/Page.vue";
import TemplatesLabelCounts from "../../templates/LabelCounts.vue";

export default {
    name: "CompareStartComponent",
    props: {
        error: {
            type: String,
            required: false,
            default: null,
        },
        skips: {
            type: Object,
            required: false,
        },
        domains: {
            type: String,
            required: false,
            default: '',
        },
        maxList: {
            type: Number,
            default: 5,
            required: false
        },
        viewType: {
            type: String,
            required: false,
            default: null,
        }
    },
    data() {
        return {
            list: '',
        };
    },
    mounted() {
        this.list = this.domains;
    },
    computed: {
        getData() {
            if (this.list) {
                return this.list.replace(/\r\n/g,"\n").split("\n").filter(item => item !== "");
            }
            return [];
        },
        count() {
            return this.getData.length;
        }
    },
    components: {
        Button,
        Textarea,
        InlineMessage,
        TemplatesPage,
        TemplatesLabelCounts,
    }
}
</script>
